export const setupProgress = {
  title: 'Configura tu cuenta',
  dismiss: 'Descartar',
  percentComplete: '{{percent}}% completado',
  completed: 'completados',
  steps: {
    websites: {
      label: 'Sitios web',
      description: 'Al menos un sitio web',
    },
    companyData: {
      label: 'Empresa',
      description: 'Industria y objetivos',
    },
    brandIdentity: {
      label: 'Identidad',
      description: 'Logo y colores',
    },
    brandVoice: {
      label: 'Voz de marca',
      description: 'Al menos una voz',
    },
  },
} as const
